module.exports = __webpack_public_path__ + "static/media/korean-female-main.3d7b4774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Reconstructions/3D/korean-female-main.jpg
// module id = 477
// module chunks = 0